import {Document} from "docx";
import Calculations from "../../../helpers/calculations";
import {noten} from "../../../data/noten";
import {sections} from "./sections";

export class Summary {
  static _calculateResultArr(user, klausur, schueler, companies) {
    console.log({user, klausur, schueler, companies})
    const company = companies.find(c => c.id === parseInt(klausur.companyId));
    const land = companies.find(c => c.id === parseInt(klausur.companyId))?.land;
    const result1 = schueler.map(s => {
      const calculations = new Calculations(s, klausur).results[land];
      console.log({calculations, land, s, klausur, company});
      const punkte = land === "Brandenburg" ? calculations.gesamtpunkte : calculations.resultPointsRounded;
      return {
        schueler: `${s.vorname} ${s.nachname}`,
        punkte
      };
    });
    return result1;
  }

  static calculateSummary(user, klausur, schueler, companies) {
    // console.log({ user, klausur, schueler, companies });
    const land = companies.find(c => c.id === parseInt(klausur.companyId))?.land;
    if (!land) return;
    // console.log({ user, klausur, schueler, companies, land });
    const result1 = schueler.map(s => {
      const calculations = new Calculations(s, klausur).results[land];
      // console.log({ calculations });
      const punkte = land === "Brandenburg" ? calculations.gesamtpunkte : calculations.resultPointsRounded;
      return {
        schueler: `${s.vorname} ${s.nachname}`,
        punkte
      };
    });
    const arr = [];
    for (let i = 0; i < 16; i++) {
      arr.push(i);
    }
    const result2 = result1.map(i => i.punkte);
    const obj = arr.reduce((acc, item) => {
      return {
        ...acc,
        [`0${item}`.slice(-2)]: {
          points: item,
          count: 0,
          note: noten[`0${item}`.slice(-2)]
        }
      };
    }, {});
    // console.log({ obj, result2 });
    result2.forEach(i => {
      if (i) obj[`0${i}`.slice(-2)].count += 1;
    });
    // console.log({ result1, result2, arr, obj });
    return obj;
  }
  static calculateAverage = (user, klausur, schueler, companies) => {
    const arr = this._calculateResultArr(user, klausur, schueler, companies).map(i => i.punkte);
    const sum = arr.reduce((acc, i) => (acc += i), 0);
    const average = arr.length ? sum / arr.length : 0;
    // console.log({ arr, sum, average }, arr.length);
    return average;
  };

  static async create(user, klausur, schueler, companies) {
    const filtered = schueler.filter(s => !s.entwurf);
    const valueObj = this.calculateSummary(user, klausur, filtered, companies);
    const average = this.calculateAverage(user, klausur, filtered, companies);
    console.log({filtered, valueObj, average});
    const document = new Document({
      sections: sections(user, klausur, filtered, companies, valueObj, average)
    });

    return document;
  }
}
